import styled from "styled-components";

import { TextField as UiTextField } from "@formant/ui/component/common/TextField";

import { Buttons } from "../../../common/Buttons";
import { Heading3 } from "../../../common/Heading3";

export const Header = styled.div`
    display: flex;
`;

export const Heading = styled(Heading3)`
    align-self: center;
    margin-top: 0;
    margin-bottom: 0;
`;

export const ButtonBar = styled(Buttons)`
    display: flex;
    justify-content: end;
`;

export const LabelWrapper = styled.div`
    display: block;
    margin-block: 1rem 0.66rem;
    margin-inline: 0.25rem;
`;

export const TextField = styled(UiTextField)`
    margin-block-end: 1rem;
    &:focus-within input[type="text"]:focus {
        /* TODO this is a odd -0.039375rem that was meant to
         * offset *something* at some point, but it can cause
         * the outer wrapper to fractionally become less than
         * a integer height value (causing visual jank on focus).
         * I'm not sure what this was _meant_ to resolve, as it
         * calculates to 63% of one pixel. but, this will *offset*
         * it back for now. This should get resolved 
         * sooner-rather-than-later.
         */
        margin-bottom: unset;
    }
`;

export const Copy = styled.p`
    max-width: 22rem;
    margin-block: 2rem;
    margin-inline: auto;
`;

export const Limit = styled.div`
    margin-block: 4.375rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
`;
